<template>
	<div
		class="panel"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header container">
				<h2 v-if="block.block_title">
					{{ block.block_title }}
				</h2>
			</div>

			<div class="teaser_wrapper overflow-hidden">
				<div v-if="block.items?.length">
					<div class="swiper-wrapper">
						<div v-for="(item, index) in block.items" :key="index" class="swiper-slide">
							<div class="row">
								<div class="col-12 position-relative">
									<div
										:id="`panel-li-02-wrapper__${block.id}`"
										class="announce_image_block"
									>
										<vueper-slides
											ref="vueperslides1"
											:infinite="false"
											:fractions="false"
											:arrows="false"
											:bullets="false"
											:fixed-height="true"
											fade
											lazy-load-on-drag
											class="hotel-slider"
										>
											<vueper-slide
												v-for="(sub_item, index_subitem) in slides"
												:key="index_subitem"
												image="null"
											>
												<template #content>
													<div :id="`panel-li-02-vueper-slider__${block.id}`">
														<div class="container">
															<div class="row">
																<!-- Info -->
																<div class="col-12 col-lg-6 mb-3">
																	<div class="vueperslide__title d-flex h-100 justify-content-between flex-column">
																		<div>
																			<div v-if="item.description" class="title title-lg pb-3 mt-0">
																				{{ sub_item.description }}
																			</div>
																			<div v-if="item.sub_description" class="title mb-3">
																				{{ sub_item.sub_description }}
																			</div>
																			<div v-if="sub_item.text" class="description mb-0" v-html="sub_item.text" />
																		</div>

																		<div
																			v-if="slides.length > 1"
																			class="d-flex align-items-start justify-content-start"
																		>
																			<div class="vueperslides__arrows">
																				<button
																					class="vueperslides__arrow vueperslides__arrow--prev"
																					@click="prevSlide"
																				/>
																				<button
																					class="vueperslides__arrow vueperslides__arrow--next"
																					@click="nextSlide"
																				/>
																			</div>
																		</div>
																	</div>
																</div>

																<!-- Image -->
																<div class="col-12 col-lg-6">
																	<div class="hotel-slider-item__item__image mt-0">
																		<img :src="sub_item.image" class="img-fluid mt-0">
																		<div class="vueperslides__fractions ml-2">
																			{{ index_subitem + 1 }} / {{ slides.length }}
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</template>
											</vueper-slide>
										</vueper-slides>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { BOOTSTRAP_BREAKPOINTS } from '~/utils/dictionaries';
import panel from '~/mixins/panel';

export default {
	name: 'PanelLi02',

	components: {
		Swiper,
		SwiperSlide,
		VueperSlides,
		VueperSlide,

	},
	directives: {
		swiper: directive,
	},
	mixins: [panel],
	data() {
		return {
			options: {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: false,
			},
			breakpoint: null,
			isAdaptive: false,
		};
	},
	computed: {
		slides() {
			const data = this.block.items;
			const formattedData = data.flatMap((item) => {
				// Извлекаем данные из родительского объекта
				const {
					description, sub_description: subDescription, text, sub_items: subItems,
				} = item;

				// Формируем новый массив, добавляя sub_items с нужными данными
				return subItems.map((subItem) => ({
					...subItem,
					description,
					subDescription,
					text,
				}));
			});
			return formattedData;
		},
		vueperslideComponent() {
			return this.$refs.vueperslides1.length ? this.$refs.vueperslides1[0] : null;
		},
	},
	watch: {
		breakpoint: {
			handler() {
				this.resizeHeightVuper();
			},
			immediate: true,
		},
	},
	mounted() {
		this.checkScreenWidth();

		window.addEventListener('resize', this.checkScreenWidth);
	},
	methods: {
		prevSlide() {
			this.vueperslideComponent.previous();
		},
		nextSlide() {
			this.vueperslideComponent.next();
		},
		setBreakpoint() {
			if (window.innerWidth <= BOOTSTRAP_BREAKPOINTS.sm) this.breakpoint = 'sm';
			else if (window.innerWidth <= BOOTSTRAP_BREAKPOINTS.md) this.breakpoint = 'md';
			else if (window.innerWidth <= BOOTSTRAP_BREAKPOINTS.lg) this.breakpoint = 'lg';
			else this.breakpoint = 'xl';
		},
		checkScreenWidth() {
			this.setBreakpoint();
			this.isAdaptive = (window.innerWidth <= [BOOTSTRAP_BREAKPOINTS.lg]);
		},
		resizeHeightVuper() {
			const slider = document.getElementById(`panel-li-02-vueper-slider__${this.block.id}`);
			const panelWrapper = document.getElementById(`panel-li-02-wrapper__${this.block.id}`);
			const sliderWrapper = panelWrapper.getElementsByClassName('vueperslides--fixed-height');
			sliderWrapper[0].style.height = `${slider.clientHeight}px`;
		},
	},
};
</script>

<style lang="scss">
	@import 'assets/styles/sk_variables';
	// For use bootstrap vars and mixins inside
	@import "assets/styles/bootstrap/scss/functions";
	@import "assets/styles/bootstrap/scss/variables";
	@import "assets/styles/bootstrap/scss/mixins";
	.vueperslides--fixed-height { height: 500px; }
	.hotel-slider {

		.vueperslides__bullets {
			bottom: 3.75rem; //60px
		}
		.vueperslides__bullet {
			transition: transform 0.2s;
		}

		.vueperslides__bullet:hover {
			transform: scale(1.2);
		}

		.vueperslides__bullet .default {
			background-color: currentColor;
			width: .4rem;
			height: .4rem;
		}
		.vueperslides__bullet--active .default {
			border-width: 6px;
		}

		.vueperslides__arrows--wrapper {
			width: 100%;
			position: absolute;
			bottom: 0;
			left: 0;
		}
		.vueperslides__arrows {
			position: relative;
			width: 5.5rem;
			height: 2.25rem;
			z-index: 1;
		}

		.vueperslides__arrow {
			align-items: center;
			background: #455fed;
			border-radius: 50%;
			display: flex;
			height: 2.25rem;
			justify-content: center;
			margin: 0;
			width: 2.25rem;
			opacity: 1;

			&:after {
				color: #fff;
				content: "";
				font-family: "sk_icons";
				font-size: 1rem;
				left: 50%;
				line-height: 1;
				position: absolute;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			&.vueperslides__arrow--next {
				right: 0rem !important;
				&:after {
					content: "";
				}
			}

			&.vueperslides__arrow--prev {
				left: 0rem !important;
			}
		}
	}

	.vueperslides__parallax-wrapper {
		&:before {
			box-shadow: none !important;
		}
		&:after {
			box-shadow: none !important;
		}
	}

</style>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-teaser.scss";

	div.hotel-slider-item {
		cursor: pointer !important;
		margin-right: 1px;

		&:after {
			content: '';
			position: absolute;
			background-color: rgba(108, 120, 182, 0.73);
			mix-blend-mode: multiply;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
		}
		&__item {
			background-color: rgba(0,0,0,.5);
			width: auto;
			height: 100%;
			display: none;

			@include media-breakpoint-up(lg) {
				display: flex;
			}
			&__title {
				text-align: left;
				color: white !important;
				.title-lg {
					border-bottom: 2px solid white;
				}
			}
		}

	}

	.panel_header {
		margin-bottom: 1rem;
	}

	.announce_image_block {
		position: relative;
		overflow: hidden;

		.swiper-navigation {
			position: absolute;
			right: 1rem;
			bottom: 1rem;
			z-index: 10;

			.btn {
				&.icon-arrow_next {
					margin-left: 0.5rem;
				}
				&:not(.disabled) {
					background-color: $white;
					&:hover {
						background-color: $primary;
					}
				}
			}
		}
	}

	.bottom-control {
		.btn {
			margin-bottom: 0.5rem;
		}
	}
</style>
